export const HOME= '/';
export const LANDING= '//';
export const SIGNUP = '/signup';
export const SIGNIN = '/signin';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const PASSWORD_FORGET = '/pw-forget';
export const ABOUT = '/about';
export const CONTACT = '/contact';
export const CREATE = '/create';
export const PROFILE = '/profile';
